import React from "react"

import { GatsbyImage } from "gatsby-plugin-image"

import ComponentFactory from "../components/parsers/ComponentFactory"
import ImageTransformer from "../components/parsers/ImageTransformer"

import { Trans } from "gatsby-plugin-react-i18next"

import * as eduNewsSectionStyles from "../styles/EduNewsSection.module.css"

const NUMBER_OF_NEWS_ITEMS = 2

const newsContent = elem => {
  const content = elem.props && elem.props.content
  if (!content) return ``

  const newsContentNode = content.childNodes.filter(node =>
    node.classNames.trim().split(/\s+/).includes("edu-news-visual-assets")
  )[0]

  return ImageTransformer(newsContentNode)
}

const newsFilterPerNav = (newsCollection, activeIndx, startingIndx) => {
  // if already within sliding window
  if (
    activeIndx >= startingIndx &&
    activeIndx < startingIndx + NUMBER_OF_NEWS_ITEMS
  )
    return newsCollection.slice(
      startingIndx,
      Math.min(startingIndx + NUMBER_OF_NEWS_ITEMS, newsCollection.length)
    )

  return newsCollection.slice(
    Math.min(
      activeIndx,
      Math.max(0, newsCollection.length - NUMBER_OF_NEWS_ITEMS)
    ),
    Math.min(activeIndx + NUMBER_OF_NEWS_ITEMS, newsCollection.length)
  )
}

export default function NewsSection(props) {
  const { content } = props

  const components = ComponentFactory(content.innerHTML)

  const title =
    components.filter(
      c => c.props.className === `icw-edu-news-section-title`
    )[0] || "Next events"

  const newsItems = components
    .filter(
      c =>
        c.props.content &&
        c.props.content.classNames.trim().split(/\s+/).includes(`cw-edu-news`)
    )
    .map((elem, idx) => ({ originalIndex: idx, newsItem: elem }))

  const [newsIndx, setNewsIndx] = React.useState(0)
  const [newsRollIndx, setNewsRollIndx] = React.useState(0)

  React.useEffect(() => {
    if (
      newsIndx < newsRollIndx ||
      newsIndx >= newsRollIndx + NUMBER_OF_NEWS_ITEMS
    )
      setNewsIndx(newsRollIndx)
  }, [newsIndx, newsRollIndx])

  const imageContent = newsContent(newsItems[newsIndx].newsItem)

  return (
    <div className={`row ${props.className} ${eduNewsSectionStyles.wrapper}`}>
      <div className={`col-12  ${eduNewsSectionStyles.titleWrapper}`}>
        <div className={`row`}>
          <div className={`col-6 ${eduNewsSectionStyles.title}`}>
            <Trans>{title}</Trans>
          </div>
        </div>

        <div className={`row`}>
          <div className={`col-12 ${eduNewsSectionStyles.newsRoll}`}>
            <div className="offset-md-1 col-md-10">
              <div className={`row ${eduNewsSectionStyles.newsHolder}`}>
                {newsFilterPerNav(newsItems, newsIndx, newsRollIndx).map(
                  (item, idx) => (
                    <div
                      key={idx}
                      className={`col-md-6 ${eduNewsSectionStyles.newsItem} ${
                        item.originalIndex === newsIndx ? `active` : ``
                      }`}
                    >
                      <a
                        href="#!"
                        onClick={evt => {
                          evt.preventDefault()
                          setNewsIndx(item.originalIndex)
                        }}
                      >
                        <>{item.newsItem}</>
                      </a>
                    </div>
                  )
                )}
              </div>
            </div>
          </div>
        </div>

        <div className={`row ${eduNewsSectionStyles.newsItemContent}`}>
          <div className={`col-12`}>
            {imageContent && (
              <GatsbyImage
                image={imageContent.image}
                alt={imageContent.alt || "Cubewise edu news photo"}
              />
            )}
          </div>
        </div>
        <div className={`row ${eduNewsSectionStyles.navigator}`}>
          <div className={`col-md-1 news-nav-btn ${newsRollIndx === 0 ? eduNewsSectionStyles.disabledNavigator : ``}`}>
          <a
                href="#!"
                className="nav-left"
                onClick={evt => {
                  evt.preventDefault()
                  if (newsRollIndx > 0)
                    setNewsRollIndx(newsRollIndx - NUMBER_OF_NEWS_ITEMS)
                }}
              >
                <i className="bi bi-chevron-left"></i>
              </a>
          </div>
          <div
            className="col-md-10"
            style={{ borderTop: `1px solid white` }}
          ></div>
          <div className={`col-md-1 news-nav-btn ${newsRollIndx >= newsItems.length - 1 ? eduNewsSectionStyles.disabledNavigator : ``}`}>
            
              <a
                href="#!"
                className="nav-right"
                onClick={evt => {
                  evt.preventDefault()
                  if (newsRollIndx < newsItems.length - 1)
                    setNewsRollIndx(newsRollIndx + NUMBER_OF_NEWS_ITEMS)
                }}
              >
                <i className="bi bi-chevron-right"></i>
              </a>
          
          </div>
        </div>
      </div>
    </div>
  )
}
